// Operational Engineering — volume / strokes / times.
//
// Pure deterministic functions. NaN on insufficient inputs, never throws.

import { asNum } from "../units";

/** strokes = volume_bbl / pumpOutput_bbl_per_stk. */
export function strokesForVolume(volumeBbl, pumpOutputBblStk) {
  const v = asNum(volumeBbl), q = asNum(pumpOutputBblStk);
  if (!Number.isFinite(v) || !Number.isFinite(q) || q <= 0) return NaN;
  return v / q;
}

/** minutes = strokes / pumpRate_spm. */
export function minutesForStrokes(strokes, pumpRateSpm) {
  const s = asNum(strokes), r = asNum(pumpRateSpm);
  if (!Number.isFinite(s) || !Number.isFinite(r) || r <= 0) return NaN;
  return s / r;
}

// Standard oilfield identity: bbl/ft = (D_h² − D_p²) / 1029.4
// where D_h is the containing inner diameter (hole or casing ID) and D_p
// is the displacing outer diameter (tubular OD). Returns NaN when either
// input is missing or the geometry is impossible (D_p ≥ D_h).
const _BBL_PER_FT_DIVISOR = 1029.4;
export function annularCapacityBblPerFt(outerInchesContaining, outerInchesDisplacing) {
  const D = asNum(outerInchesContaining);
  const d = asNum(outerInchesDisplacing);
  if (!Number.isFinite(D) || !Number.isFinite(d)) return NaN;
  if (D <= 0 || d <= 0 || d >= D) return NaN;
  return (D * D - d * d) / _BBL_PER_FT_DIVISOR;
}
